import { EServiceTemplateDataProcessingInCountriesSpecialTreatment } from "@devowl-wp/api-real-cookie-banner";
import { CONTEXT_LATEST_DESIGN_VERSION } from "../types";
function calculateUnsafeCountries(_ref) {
  let {
    dataProcessingInCountries,
    safeCountries,
    specialTreatments = [],
    designVersion = CONTEXT_LATEST_DESIGN_VERSION
  } = _ref;
  const useSpecialTreatments = designVersion > 4 ? specialTreatments : [];
  return dataProcessingInCountries.filter(c => useSpecialTreatments.indexOf(EServiceTemplateDataProcessingInCountriesSpecialTreatment.StandardContractualClauses) > -1 ? false : safeCountries.indexOf(c) === -1 || c === "US" && useSpecialTreatments.indexOf(EServiceTemplateDataProcessingInCountriesSpecialTreatment.ProviderIsSelfCertifiedTransAtlanticDataPrivacyFramework) === -1);
}
export { calculateUnsafeCountries };